import { connect } from "react-redux";
import { PageLibraryAppointments } from "senac-components";
import { RootState, AppDispatch } from "../store";
import {
  ContentFilters,
  ContentOptionAppointments,
  MenuOptions,
  PageHeaderOptionItem,
  PageLibraryHeaderOptionItem,
} from "senac-components/dist/pages/Mobile/PageInterfaces";
import { PageLibraryAppointmentsDispach, PageLibraryAppointmentsState } from "senac-components/dist/pages/Mobile/PageLibraryAppointments";
import { commonSlice, contentSlice } from "../store/reducers";
import { ContentMark } from "senac-components/dist/pages/Mobile/PageInterfaces";
import { filterContent } from "../store/reducers/common";
import { showContentDetail, showContentDetailWithMarks } from "../store/reducers/contentSlice";

const mapState = (state: RootState) => 
{
  var allContent = state.contentState.allContents;
  var data = state.userDataState.userData.filter(p=> p.targetType == "ManagedContentReference" && p.contextType == "ManagedContent");
  var marks:ContentMark[] = [];

  data.forEach(userData=>
  {
    var mark = marks.find(p=> p.uid == userData.contextUid);
    var content = allContent.find(p=> p.uid == userData.contextUid);
    if (!content) return;

    if (!mark)
    {
      //todo: alterar para tipo number
      mark = { uid: userData.contextUid, title: content.title, image: content.image};
      marks.push(mark);
    }

    var total = Number.parseInt(mark.numberMark ?? "0");
    total ++;

    mark.numberMark = total.toString();
  });

  let result: PageLibraryAppointmentsState = { contents:marks };

  return result;
};

const mapDispatch = (dispatch: AppDispatch) => 
{
  const result: PageLibraryAppointmentsDispach = 
  {
    onChangeFilter: (filter:ContentFilters) => {
      if (filter.query == undefined) return;
      dispatch(filterContent({ query: filter.query }));
    },
    onSelectedHeaderBack: () => dispatch(commonSlice.actions.backPage()),
    onSelectedHeaderMenuOption: (option: PageLibraryHeaderOptionItem) =>dispatch(commonSlice.actions.goToLibraryOption(option)),
    onSelectedNavigationPageOption: (option: MenuOptions) => dispatch(commonSlice.actions.goToPage(option)),
    onClickContent: (content, marks) => {
      if (!content.uid) return;
      dispatch(showContentDetail(content.uid));
    }
  };

  return result;
};

const WPageLibraryAppointments = connect(mapState,mapDispatch)(PageLibraryAppointments);
export { WPageLibraryAppointments };
